import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Sarah M.",
    location: "Hiawatha, KS",
    quote:
      "Koehn Cooling installed our new Lennox furnace right before a cold snap. Professional, on time, and the price was exactly what they quoted.",
  },
  {
    name: "Mike R.",
    location: "Horton, KS",
    quote:
      "Our AC died on the hottest day of the year. They had a technician at our house within hours. Fair, friendly, and fast.",
  },
  {
    name: "Linda K.",
    location: "Sabetha, KS",
    quote:
      "We've used them for routine maintenance for years. Honest, knowledgeable, and they treat us like family every visit.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="py-20 sm:py-28 bg-[#0F172A] text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 hero-grid opacity-30" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs font-semibold uppercase tracking-widest text-[#E31837] mb-3">
            Customer Reviews
          </div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            Loved by neighbors across Brown County.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {REVIEWS.map((r, idx) => (
            <div
              key={idx}
              data-testid={`testimonial-${idx}`}
              className="bg-white/5 backdrop-blur rounded-3xl p-8 border border-white/10 hover:border-white/30 transition-colors"
            >
              <Quote className="w-8 h-8 text-[#E31837] mb-4" />
              <div className="flex gap-0.5 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-[#E31837]" fill="#E31837" />
                ))}
              </div>
              <p className="text-slate-200 leading-relaxed mb-6">"{r.quote}"</p>
              <div className="border-t border-white/10 pt-4">
                <div className="font-display font-bold text-white">{r.name}</div>
                <div className="text-sm text-slate-400">{r.location}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
